import './aitest.css'
import React from 'react'
import { Delete } from "@mui/icons-material"
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext'
import {useState} from "react";

export const DisplayChosenTests = ({ chat, clickHandler, deleteHandler, setTemplateName, handleFocus }) => {
    
    const [openDialog, handleDisplay] = useState(false);
    const [openConfirmDialog, handleConfirmDisplay] = useState(false);
    const [dialogtext, setDialogText] = useState('');

    let {
        deleteBoughtTest,
      } = React.useContext(AITestContext);

      let {
        changeLanguage,
      } = React.useContext(StatusContext);

    
    const alertYes = () => {
        closeDialogBox()
        deleteBoughtTest(chat)
      }

      const alertCancel = () => {
        closeDialogBox()
      }

      const closeDialogBox = () => {
        handleDisplay(false);
     };
  
     
     const openDialogBox = () => {
        handleDisplay(true);
     };

     const closeConfirmDialogBox = () => {
      handleConfirmDisplay(false);
    };


    const confirmYes = () => {
      closeConfirmDialogBox()
    
    }

     const handleDisplayTest = () => {
    
      clickHandler(chat)
      setTemplateName(chat.chatname)
      handleFocus()

     }
    

     const handleDelete = () => {

        setDialogText(`'${chat.chatname}'.                   ${changeLanguage('aitest', 'text17')}`)

        openDialogBox()
       
          
    }

   
    return (
      <div className='selectTest'>
      <div className="aitestChooseListItem" key={chat.id}>
        <div style={{marginTop: '5px'}}>
            <Delete className="promptIcon" onClick={handleDelete} />
        </div>

         <div className="aitestChooseExpiration" >
             <span className='aitestExpiration' key={chat.id}>{chat.purchasedate}</span>
          </div>
       
          
            <div className="displayTestName" key={chat.id} onClick={handleDisplayTest }>
                 <span >{chat.chatname}</span>
                 <div className="aitestByAuthor">
                {changeLanguage('aitest', 'by')} {chat.creator_name}
                </div>
            </div>
        </div>
    
        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogtext}/>
        <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogtext}/>
      </div>
    )
}